import styled from 'styled-components';

export interface IconWrapperProps {
  size?: 'small' | 'medium' | 'large';
  variant?: 'default' | 'gradient';
}

export const IconWrapper = styled.div<IconWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  ${({ size = 'medium', theme }) => {
    switch (size) {
      case 'small':
        return `
          width: 40px;
          height: 40px;
          svg { width: 20px; height: 20px; }
        `;
      case 'large':
        return `
          width: 64px;
          height: 64px;
          svg { width: 32px; height: 32px; }

          @media (max-width: ${theme.breakpoints.mobile}) {
            width: 48px;
            height: 48px;
            svg { width: 24px; height: 24px; }
          }
        `;
      default:
        return `
          width: 48px;
          height: 48px;
          svg { width: 24px; height: 24px; }
        `;
    }
  }}

  ${({ variant = 'default' }) => {
    switch (variant) {
      case 'gradient':
        return `
          background: linear-gradient(135deg, #1a3156 0%, #294e89 100%);
          color: white;
        `;
      default:
        return `
          color: black;
        `;
    }
  }}
`;
